<div class="md-form md-outline mb-0 mt-3">
  <textarea [ngModel]="value" (ngModelChange)="onInput($event)" id="form-input" class="form-control textarea form-{{color}}" rows="1" type="text" mdbInput style="resize:none;"></textarea>
  <label for="form-input">{{ label | translate }}</label>
</div>